module.exports = __webpack_public_path__ + "img/mapa-ilus6.c747d173.png";